<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Teaching &amp; Non Teaching</h1>
      <ul>
        <li><a class="active" routerLink="/">Home</a></li>
        <li><a>Faculty</a></li>
        <li>Teaching &amp; Non Teaching</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 section-layout">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <faculty-menu></faculty-menu>
        </div>
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-12 mb-70">
              <div class="blog-item">
                <div class="blog-content">
                  <h3 class="blog-title">Teaching &amp; Non Teaching</h3>
                  <p class="blog-table-wrap">
                    <a href="/assets/college/sapthagirifaculty.pdf" target="_blank">Staff Details  (click to view)</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

